'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _forms = require('utils/forms');

var _components2 = require('components');

var _forms2 = require('metadata/forms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const syncValidation = formSyncValidation({
//     requiredValues: ['dateOfBirth', 'nationality'],
//     dateValues: [
//         { value: 'dateOfBirth' }
//     ]
//     requirements: {
//         NAME: ['']
//     }
// })

var passportExpiresAckno = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formPassportDetails.passportExpiresAckno',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'h4',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formPassportDetails.passportExpiresAcknoTitle',
                    defaultMessage: 'Passport Expires Soon' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formPassportDetails.passportExpiresAcknoText',
                    defaultMessage: 'The passport we have on file for you is expiring in less\n                                         than 6 months of the last day of your trip. Many\n                                         countries require at least 6 months passport\n                                         validity from your date of departure, please check\n                                         directly with the embassy/consulate of the countries\n                                         you are visiting to ensure entry.' })
            )
        )
    } });

var PassportInformation = function PassportInformation(_ref) {
    var intl = _ref.intl,
        hiddenValues = _ref.hiddenValues,
        initialValues = _ref.initialValues,
        requirementsByCode = _ref.requirementsByCode,
        bookingId = _ref.bookingId,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        submitting = _ref.submitting;

    // We only have one resource href here, so nab it from GENDER requirement and use throughout
    var customerHref = requirementsByCode.GENDER.fieldResourceHrefsByType.customers;

    // We need to awkwardly combine name + middle_name requirements by modifying them
    // depending on the status/last_modified data of the other
    // - status is 'COMPLETE' only if both are complete
    // - last_modified data is that of the most recently modified requirement
    // - both must be submitted together (for sync validation)
    // (we assume that if requirement NAME is present, so will MIDDLE_NAME)
    var hasBothNameReqs = requirementsByCode.NAME && requirementsByCode.MIDDLE_NAME;
    var hasJustNameReq = requirementsByCode.NAME && !requirementsByCode.MIDDLE_NAME;
    if (hasBothNameReqs) {
        // Determine status
        var nameIsComplete = requirementsByCode.NAME.status === 'COMPLETE';
        var middleNameIsComplete = requirementsByCode.MIDDLE_NAME.status === 'COMPLETE';
        if (!nameIsComplete || !middleNameIsComplete) {
            requirementsByCode.NAME.status = 'INCOMPLETE';
            requirementsByCode.MIDDLE_NAME.status = 'INCOMPLETE';
        }
        // Find most recent change
        var nameModDate = new Date(requirementsByCode.NAME.last_modified.date);
        var middleNameModDate = new Date(requirementsByCode.MIDDLE_NAME.last_modified.date);
        if (nameModDate > middleNameModDate) {
            requirementsByCode.MIDDLE_NAME.last_modified = requirementsByCode.NAME.last_modified;
        } else if (middleNameModDate > nameModDate) {
            requirementsByCode.NAME.last_modified = requirementsByCode.MIDDLE_NAME.last_modified;
        }
    }

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
        _react2.default.createElement(_components2.FormInstructionalText, {
            instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formPassportDetails.instructionalText',
                defaultMessage: 'Please ensure the following is {asAppearsOnPassport}.',
                values: { asAppearsOnPassport: _react2.default.createElement(
                        'em',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formPassportDetails.instructionalText.asAppears',
                            defaultMessage: 'as it appears on your passport' })
                    ) } }) }),
        _react2.default.createElement(
            'form',
            null,
            hasJustNameReq && _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.NAME,
                fields: [{
                    id: 'firstName',
                    label: intl.formatMessage(_forms2.formLabels.firstName),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'firstName',
                        name: '[\'' + customerHref + '\'].name.legal_first_name',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: requirementsByCode.NAME })
                }, {
                    id: 'lastName',
                    label: intl.formatMessage(_forms2.formLabels.lastName),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'lastName',
                        name: '[\'' + customerHref + '\'].name.legal_last_name',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: requirementsByCode.NAME })
                }] }),
            hasBothNameReqs && _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.NAME,
                fields: [{
                    id: 'firstName',
                    label: intl.formatMessage(_forms2.formLabels.firstName),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'firstName',
                        name: '[\'' + customerHref + '\'].name.legal_first_name',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: requirementsByCode.NAME })
                }, {
                    id: 'middleName',
                    label: intl.formatMessage(_forms2.formLabels.middleName),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'middleName',
                        name: '[\'' + customerHref + '\'].name.legal_middle_name',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: requirementsByCode.MIDDLE_NAME })
                }, (0, _extends3.default)({}, (0, _forms.generateOverride)({
                    intl: intl,
                    id: 'middleNameOverride',
                    requirement: requirementsByCode.MIDDLE_NAME,
                    overrideLabels: _forms2.formOverrides.passportInformation.MIDDLE_NAME,
                    bookingId: bookingId,
                    initialValues: initialValues
                })), {
                    id: 'lastName',
                    label: intl.formatMessage(_forms2.formLabels.lastName),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'lastName',
                        name: '[\'' + customerHref + '\'].name.legal_last_name',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: requirementsByCode.NAME,
                        'aria-hidden': 'false' })
                }] }),
            _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.GENDER,
                fields: [{
                    id: 'gender',
                    label: intl.formatMessage(_forms2.formLabels.gender),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'gender',
                        name: '[\'' + customerHref + '\'].gender',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'select',
                        options: (0, _keys2.default)(_forms2.formOptions.genderLabels).map(function (key) {
                            return {
                                label: intl.formatMessage(_forms2.formOptions.genderLabels[key]),
                                value: _forms2.formOptions.genderValues[key]
                            };
                        }),
                        requirement: requirementsByCode.GENDER })
                }] }),
            _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.NATIONALITY,
                fields: [{
                    id: 'nationality',
                    label: intl.formatMessage(_forms2.formLabels.nationality),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'nationality',
                        name: '[\'' + customerHref + '\'].nationality.id',
                        hiddenValues: hiddenValues,
                        component: _components2.SelectCachedInput,
                        loadResource: 'nationalities',
                        fuzzyParam: 'name',
                        format: function format(value) {
                            return '' + value;
                        } // ensure we get back a string
                        , requirement: requirementsByCode.NATIONALITY })
                }] }),
            _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.DATE_OF_BIRTH,
                fields: [{
                    id: 'dateOfBirth',
                    label: intl.formatMessage(_forms2.formLabels.dateOfBirth),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'dateOfBirth',
                        name: '[\'' + customerHref + '\'].date_of_birth',
                        hiddenValues: hiddenValues,
                        component: _components2.SeparatedDateInput,
                        type: 'date',
                        requirement: requirementsByCode.DATE_OF_BIRTH })
                }] }),
            _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.PLACE_OF_BIRTH,
                fields: [{
                    id: 'placeOfBirth',
                    label: intl.formatMessage(_forms2.formLabels.placeOfBirth),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'placeOfBirth',
                        name: '[\'' + customerHref + '\'].place_of_birth',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: requirementsByCode.PLACE_OF_BIRTH })
                }] }),
            _react2.default.createElement(_components2.FormInstructionalText, {
                instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formPassportDetails.passportInformation',
                    defaultMessage: 'Please ensure the information you enter is {asAppearsOnPassport}',
                    values: { asAppearsOnPassport: _react2.default.createElement(
                            'em',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formPassportDetails.formHelp.passportInfo',
                                defaultMessage: 'for the passport you are travelling with.' })
                        ) } })
            }),
            _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.PASSPORT_NUMBER,
                fields: [{
                    id: 'passportNumber',
                    label: intl.formatMessage(_forms2.formLabels.passportNumber),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'passportNumber',
                        name: '[\'' + customerHref + '\'].passport.number',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: requirementsByCode.PASSPORT_NUMBER })
                }] }),
            _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.PASSPORT_ISSUE_DATE,
                fields: [{
                    id: 'issueDate',
                    label: intl.formatMessage(_forms2.formLabels.issueDate),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'issueDate',
                        name: '[\'' + customerHref + '\'].passport.issue_date',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'date',
                        requirement: requirementsByCode.PASSPORT_ISSUE_DATE })
                }] }),
            _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.PASSPORT_PLACE_OF_ISSUE,
                fields: [{
                    id: 'placeOfIssue',
                    label: intl.formatMessage(_forms2.formLabels.placeOfIssue),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'placeOfIssue',
                        name: '[\'' + customerHref + '\'].passport.place_of_issue',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: requirementsByCode.PASSPORT_PLACE_OF_ISSUE })
                }] }),
            _react2.default.createElement(_components2.FieldSet, {
                requirement: requirementsByCode.PASSPORT_EXPIRY_DATE,
                fields: [{
                    id: 'expiryDate',
                    label: intl.formatMessage(_forms2.formLabels.expiryDate),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'expiryDate',
                        name: '[\'' + customerHref + '\'].passport.expiry_date',
                        hiddenValues: hiddenValues,
                        component: _components2.SeparatedDateInput,
                        type: 'date',
                        requirement: requirementsByCode.PASSPORT_EXPIRY_DATE })
                }] }),
            requirementsByCode.PASSPORT_EXPIRES_SOON && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components2.FormStubText, { stubText: passportExpiresAckno }),
                _react2.default.createElement(_components2.FieldSet, {
                    requirement: requirementsByCode.PASSPORT_EXPIRES_SOON,
                    fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                        intl: intl,
                        id: 'passportExpiresAckno',
                        requirement: requirementsByCode.PASSPORT_EXPIRES_SOON,
                        overrideLabels: _forms2.formOverrides.acknowledgements,
                        bookingId: bookingId,
                        initialValues: initialValues
                    }))] })
            ),
            _react2.default.createElement(_components2.FormSubmit, {
                handleSubmit: handleSubmit,
                invalid: invalid,
                pristine: pristine,
                submitting: submitting,
                submitSucceeded: submitSucceeded,
                isFetchingRequirementData: isFetchingRequirementData })
        )
    );
};
PassportInformation.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    hiddenValues: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: 'passportInformation',
    enableReinitialize: true
})(PassportInformation));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/PassportInformation.js
// module id = 1324
// module chunks = 0